<div class="app-admin-wrap layout-sidebar-large layout-auth-bg">
  <div class="auth-layout-wrap">
    <router-outlet></router-outlet>
  </div>
</div>
